<template>
  <div>
    <v-flex class="pb-16 highlighted-information">
      <div class="highlighted-information-container">
        <div
          class="highlighted-information-container-header"
          :class="[{ checked: form.highlightedData.ageRestriction.show }]"
          @click="
            form.highlightedData.ageRestriction.show = !form.highlightedData.ageRestriction.show
          "
        >
          <v-checkbox
            v-model="form.highlightedData.ageRestriction.show"
            label="Age Restriction"
            @click="e => e.preventDefault()"
          />
        </div>

        <div
          v-if="form.highlightedData.ageRestriction.show"
          class="highlighted-information-container-content"
          @click="e => e.preventDefault()"
        >
          <p>Minimum age limit</p>
          <v-radio-group v-model="form.highlightedData.ageRestriction.enabled" row>
            <v-radio label="Yes" :value="true" />
            <v-radio label="No" :value="false" />
          </v-radio-group>
          <text-field
            v-model.number="form.highlightedData.ageRestriction.value"
            type="number"
            step="1"
            label="Minimum age limit"
            full-width
            :disabled="!form.highlightedData.ageRestriction.enabled"
            :validator="vs && vs.highlightedData.ageRestriction.value"
          />
        </div>
      </div>

      <br>

      <div class="highlighted-information-container">
        <div
          class="highlighted-information-container-header"
          :class="[{ checked: form.highlightedData.freeEntranceWithAgeLimit.show }]"
          @click="
            form.highlightedData.freeEntranceWithAgeLimit.show =
              !form.highlightedData.freeEntranceWithAgeLimit.show
          "
        >
          <v-checkbox
            v-model="form.highlightedData.freeEntranceWithAgeLimit.show"
            label="Entrance for children under certain age"
            @click="e => e.preventDefault()"
          />
        </div>

        <div
          v-if="form.highlightedData.freeEntranceWithAgeLimit.show"
          class="highlighted-information-container-content"
          @click="e => e.preventDefault()"
        >
          <p>Free entrance for children under certain age</p>
          <v-radio-group v-model="form.highlightedData.freeEntranceWithAgeLimit.enabled" row>
            <v-radio label="Yes" :value="true" />
            <v-radio label="No" :value="false" />
          </v-radio-group>

          <text-field
            v-model.number="form.highlightedData.freeEntranceWithAgeLimit.value"
            type="number"
            step="1"
            label="Age"
            box
            full-width
            :disabled="!form.highlightedData.freeEntranceWithAgeLimit.enabled"
            :validator="vs && vs.highlightedData.freeEntranceWithAgeLimit.value"
          />
        </div>
      </div>

      <br>

      <div class="highlighted-information-container">
        <div
          class="highlighted-information-container-header"
          :class="[{ checked: form.highlightedData.tableReservation.show }]"
          @click="
            form.highlightedData.tableReservation.show = !form.highlightedData.tableReservation.show
          "
        >
          <v-checkbox
            v-model="form.highlightedData.tableReservation.show"
            label="Table reservation"
            @click="e => e.preventDefault()"
          />
        </div>

        <div
          v-if="form.highlightedData.tableReservation.show"
          class="highlighted-information-container-content"
          @click="e => e.preventDefault()"
        >
          <v-radio-group v-model="form.highlightedData.tableReservation.enabled" row>
            <v-radio label="Yes" :value="true" />
            <v-radio label="No" :value="false" />
          </v-radio-group>
        </div>
      </div>
    </v-flex>
  </div>
</template>

<script>
export default {
  name: 'highlights-form',
  components: {},
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: this.initialValues,
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.highlighted-information {
  padding-bottom: 40px;
}

.highlighted-information-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #ffffff;
  border: 0.125rem solid #d9d9d9;
  border-radius: 0.5rem;
}

.highlighted-information-container-header {
  cursor: pointer;
  padding: 0 1rem;
}

.highlighted-information-container-header ::v-deep .v-label {
  pointer-events: none;
}

.highlighted-information-container-header.checked ::v-deep .v-label {
  color: #0277bd;
  transform: none !important;
}

.highlighted-information-container-content {
  border-top: 0.125rem solid #d9d9d9;
  padding: 0.5rem 1rem;
}

@media screen and (min-width: 1024px) {
  .highlighted-information-container-content {
    padding: 1.5rem;
  }

  .highlighted-information-container-header {
    padding: 0 1.5rem;
  }
}
</style>
